<header-title [model]="headerTitle"></header-title>
<section role="main" class="content-body tab-menu-opened" *ngIf="headerTitle">
    <div class="row">
        <div class="col">
            <section class="card">
                <header class="card-header">
                    <h2 class="card-title">{{ headerTitle.title }}</h2>
                </header>
                <div class="card-body py-5">
                    <form *ngIf="auditDetailsFormGroup" (submit)="updateAudit()" [formGroup]="auditDetailsFormGroup">
                        <section class="panel">
                            <div class="panel-body">
                                <div *ngIf="!auditDetailsModel.isActive" class="alert alert-warning" role="alert">
                                    This Audit is not active.
                                </div>
                                <error-message [errors]="errors"></error-message>

                                <div class="row mt-3">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">
                                                Name
                                            </label>
                                            <h4 *ngIf="!isEditMode">{{auditDetailsFormGroup.value.name}}</h4>
                                            <input *ngIf="isEditMode" type="text" class="form-control" formControlName="name" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-md-6">
                                        <label class="control-label">
                                            Is Active
                                        </label>
                                        <input type="checkbox" id="isActive" name="isActive" class="form-control" formControlName="isActive" appToggle [isDisabled]="!isEditMode" />
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label class="control-label"> Description </label>
                                            <textarea *ngIf="isEditMode" class="form-control" formControlName="description" [readOnly]="!isEditMode" rows="2"></textarea>
                                            <h4 *ngIf="!isEditMode">{{auditDetailsFormGroup.value.description}}</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-md-12">
                                        <div class="tabs">
                                            <ul class="nav nav-tabs">
                                                <li class="nav-item active">
                                                    <a class="nav-link" href="#popular" data-toggle="tab"> Modules</a>
                                                </li>
                                            </ul>
                                            <div class="tab-content">
                                                <div id="popular" class="tab-pane active">
                                                    <app-audit-module-list [auditId]="auditId" [isEditMode]="isEditMode"></app-audit-module-list>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <footer class="panel-footer mt-3">
                                <div class="row">
                                    <div class="col-sm-9 col-sm-offset-3">
                                        <button class="btn btn-primary" type="button" (click)="toggleEditMode()" *ngIf="!isEditMode">Edit</button>
                                        <button class="btn btn-info ml-1" type="button" (click)="onBack()" *ngIf="!isEditMode">Back</button>
                                        <button class="btn btn-danger mr-1" type="button" (click)="toggleEditMode()" *ngIf="isEditMode">Cancel</button>
                                        <button class="btn btn-success" type="submit" *ngIf="isEditMode">Save</button>
                                    </div>
                                </div>
                            </footer>
                        </section>
                    </form>
                </div>
            </section>
        </div>
    </div>
</section>

<app-alert-message (successClicked)="successClicked($event)"
                   (onHide)="onHide($event)"
                   [title]="'Success'"
                   [message]="'The Audit Updated'">
</app-alert-message>
